import { render, staticRenderFns } from "./CardRoleEditComponent.vue?vue&type=template&id=bbd3a4ea&scoped=true"
import script from "./CardRoleEditComponent.vue?vue&type=script&lang=js"
export * from "./CardRoleEditComponent.vue?vue&type=script&lang=js"
import style0 from "./CardRoleEditComponent.vue?vue&type=style&index=0&id=bbd3a4ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd3a4ea",
  null
  
)

export default component.exports